// HDSRのaction
import * as AppUser from '../constants/AppUser';
import * as HDSRConst from '../constants/HDSR';
import { AppUserAPI } from '../api/AppUser';
import { HDSRAPI } from '../api/HDSRAPI';

/**
 * HDS-Rを取得.
 *
 * @param {string} uniqueId
 * @param {string} yearMonth 月日(そのまま帰す).
 * @param {number} unixTime Unix Time. 
 * @returns
 */
const runGetHDSRDataAPI = (uniqueId: string, yearMonth: string, unixTime: number) => {
  // HDS-RのAPI
  const hdsrAPI = HDSRAPI.instance;
  if (hdsrAPI === null) {
    return {
      type: HDSRConst.ERROR,
      hdsr: null,
    };
  }

  return hdsrAPI.getHDSRLatestCount(
    uniqueId, unixTime, () => {
      return {
        type: HDSRConst.LOADING,
        result: null,
      };
    },
    (state: any, result: any) => {
      switch (state) {
        case HDSRConst.LOADING:
          return {
            type: HDSRConst.LOADING,
            result: null,
          };
        case HDSRConst.ERROR:
          return {
            type: HDSRConst.ERROR,
            result: {
              yearMonth: yearMonth,
              hdsr: null,
            }
          };
        case HDSRConst.SUCCESS:
          return {
            type: HDSRConst.SUCCESS,
            result: {
              yearMonth: yearMonth,
              hdsr: result,
            }
          };
        default:
          return {
            type: HDSRConst.ERROR,
            result: null,
          };
      }
    }
  );
};

/**
 * HDS-Rに必要な情報を取得する.
 * ユニークID取得->HDSRのAPIコール.
 *
 * @param {string} userId
 * @param {string} yearMonth
 * @param {number} unixTime
 * @returns
 */
export const getHDSRData = (userId: string, yearMonth: string, unixTime: number) => {
  // ユニークキーを取るためのAPI
  const appUserAPI = AppUserAPI.instance;
  if (appUserAPI === null) {
    return {
      type: HDSRConst.ERROR,
      result: '不明なエラーが発生しました.',
    };
  }

  // アプリユーザーAPI(ユニークIDのを取るためだけに使う).
  return appUserAPI.getAppUser(
    userId,
    () => {
      return {
        type: HDSRConst.LOADING,
        result: null,
      };
    },
    // ステータス,結果（値 or エラーメッセージ）
    (statusOfGetUser: any, resultOfGetUser: any) => {
      switch (statusOfGetUser) {
        case AppUser.LOADING:
          return {
            type: HDSRConst.LOADING,
            result: null,
          };
        case AppUser.ERROR:
          return {
            type: HDSRConst.ERROR,
            result: resultOfGetUser,
          };
        case AppUser.SUCCESS:
          const uniqueId = (resultOfGetUser.data as AppUser.ResponseData).unique_id;
          return runGetHDSRDataAPI(uniqueId, yearMonth, unixTime);
        default:
          return {
            type: HDSRConst.ERROR,
            result: '不明なエラーが発生しました.',
          };
      }
    }
  );
};

/**
 * 初期化する.
 *
 * @returns
 */
export const initialize = () => {
  return {
    type: HDSRConst.INITIALIZE,
  };
};



// WEBPACK FOOTER //
// ./src/actions/HDSR.tsx